import React from 'react'

export default function InvestmentManagement() {
    return (
        <div>
            <p>
                If there is one thing that the last few years have shown us, is that markets are unpredictable. 
                Our advice is client-centered and client-specific. We focus on understanding you, your unique goals 
                and where each fits into your life. We are committed to helping you pursue your investment goals through 
                sound advice and diligent oversight of your investment portfolio that is customized to align with your 
                individual goals and structured around your risk tolerance. 
            </p>

            <h5 className='title_h5'>We can help you plan for your financial future with confidence and precision by</h5>

            <ul>    
                <li> Ensuring there is a reliable place to get money when you need it. </li>
                <li> Understanding your personal tolerance for risk. </li>
                <li> Developing asset allocation strategies for your investment portfolio. </li>
                <li> Selecting investments for your portfolio that match your objectives. </li>
                <li> Establish strategies to manage and monitor your investment portfolio. </li>
                <li> Periodically review goals, risk tolerance, portfolio performance and strategies.     </li>
            </ul>

        </div>
    )
}